module.exports = __webpack_public_path__ + "static/media/circle.18486f14.png";